import React from 'react';
import PropTypes from 'prop-types';
import { consistentString } from '../../utils/content-formatting';
// Components
import { CTAAssembly } from '../cta';
// Styles
import { useLayout } from '../layout/context';
import { Container } from '../styled/containers';
import { Banner, Header } from './styles';

const CTABanner = ({ cta, headerText, bannerColor, removeMarginBottom }) => {
  const { insideSideBar, insideContainer } = useLayout();
  return (
    <Banner
      $bannerColor={bannerColor}
      $removeMarginBottom={removeMarginBottom}
      $sidebar={insideSideBar}
    >
      <Container $padding={!insideContainer || bannerColor !== 'transparent'}>
        {headerText ? (
          <Header $bannerColor={bannerColor}>{headerText}</Header>
        ) : null}
        <CTAAssembly
          contentfulData={cta}
          className="tracking-banner-cta"
          marginBottom={false}
        />
      </Container>
    </Banner>
  );
};

CTABanner.propTypes = {
  cta: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  headerText: PropTypes.string.isRequired,
  // NOTE: only black and transparent, rest are deprecated following rebrand
  bannerColor: PropTypes.oneOf([
    'transparent',
    'red',
    'san-marino-blue',
    'black',
  ]),
  removeMarginBottom: PropTypes.bool,
};

CTABanner.defaultProps = {
  bannerColor: 'transparent',
};

export default CTABanner;

export const CTABannerAssembly = ({ contentfulData }) => {
  if (contentfulData.cta && contentfulData.cta[0]) {
    return (
      <CTABanner
        headerText={contentfulData.ctaHeaderText}
        removeMarginBottom={contentfulData.removeMarginBottom}
        cta={contentfulData.cta && contentfulData.cta[0]}
        bannerColor={consistentString(
          contentfulData.bannerColor || 'transparent'
        )}
      />
    );
  }
  return null;
};

CTABannerAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
